import APIS from 'src/apis';
import ModuleDetailModel from 'src/models/response/ModuleDetail';
import CourseCard from 'src/models/response/CourseCard';
import Auth from './auth';

export default class ModuleService {

  static async getBookListByBlockId(id) {
    const res = await APIS.home.getAllBookList(Auth.getToken());
    return ModuleDetailModel.fromRes(res.data.result, id);
  }

  static async getBookListCourse(id) {
    const res = await APIS.bookList.getBookListDetail(id, Auth.getToken());

    return res.data.result.map((el) => CourseCard.fromRes(el));
  }
}
